module.exports = __webpack_public_path__ + "static/sport/bgi-tag-right.f2d4b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-tag-right.png
// module id = FLOZ
// module chunks = 0